import { Button } from '@sunwebgroup/uds-ui/button'
import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { useIntl } from '@/intl'
import { DurationDropdownFilter } from '@/scopes/prices/components/Filters/DurationDropdownFilter'
import { GroupedAirportFilter } from '@/scopes/prices/components/Filters/GroupedAirportFilter'
import { MealPlanFilter } from '@/scopes/prices/components/Filters/MealPlanFilter'
import { ParticipantsDropdownFilter } from '@/scopes/prices/components/Filters/ParticipantsDropdownFilter'
import { RoomTypeFilter } from '@/scopes/prices/components/Filters/RoomTypeFilter'
import { TransportTypeFilter } from '@/scopes/prices/components/Filters/TransportTypeFilter'
import { getFiltersSelector, isAccommodationAvailableSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './index.module.css'

export function Filters() {
  const intl = useIntl()
  const { error } = usePricesSelector(getFiltersSelector)
  const { isFlightOnly } = usePricesSelector(isAccommodationAvailableSelector)

  if (error) {
    return (
      <Dialog
        icon="FaceSad"
        text={intl.formatMessage({ id: 'prices_filters_error_title' })}
        supportingText={intl.formatMessage({ id: 'prices_filters_error_message' })}
        type="custom"
        className={styles.contentUnavailableWrapper}
        actionsSlot={(
          <Button onClick={() => window.location.reload()}>
            {intl.formatMessage({ id: 'prices_error_reload_button' })}
          </Button>
        )}
      />
    )
  }

  return (
    <div className={styles.wrapper}>
      <ParticipantsDropdownFilter isFlightOnly={isFlightOnly} />
      <DurationDropdownFilter />
      <GroupedAirportFilter />
      <RoomTypeFilter isFlightOnly={isFlightOnly} />
      <MealPlanFilter isFlightOnly={isFlightOnly} />
      <TransportTypeFilter isFlightOnly={isFlightOnly} />
    </div>
  )
}
